import { createRoot } from 'react-dom/client'
import { CssVarsProvider } from '@mui/joy'
import { Provider as JotaiProvider } from 'jotai'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { theme } from '../theme'
import axios from 'axios'

import '../i18n'
import GarageDetailSearch from '../components/garage-detail-search'
import { API_KEY, API_VERSION } from '../constants'
import { persistReservationTokenFromElement } from '@/checkout-session-token'
import SuggestedStartTimeSnackbarScope from '@/components/suggested-start-time-snackbar-scope'

const queryClient = new QueryClient()

axios.defaults.headers.common['x-api-key'] = API_KEY
axios.defaults.headers.common['x-api-version'] = API_VERSION

function GarageDetailSearchRoot({
    garageId,
    garageAddress,
    showPopup,
    popupText,
}: {
    garageId: string,
    garageAddress: string,
    showPopup: boolean,
    popupText: string,
}) {
    return (
        <JotaiProvider>
            <CssVarsProvider theme={theme}>
                <QueryClientProvider client={queryClient}>
                    <SuggestedStartTimeSnackbarScope placement="website-detail">
                        <GarageDetailSearch
                            garageId={garageId}
                            garageAddress={garageAddress}
                            showPopup={showPopup}
                            popupText={popupText}
                        />
                    </SuggestedStartTimeSnackbarScope>
                </QueryClientProvider>
            </CssVarsProvider>
        </JotaiProvider>
    )
}
  
const domNode = document.getElementById('react-garage-detail-search')

if (!domNode) throw new Error('Missing #react-garage-detail-search root')

persistReservationTokenFromElement(domNode)

const garageId = domNode.getAttribute('garage-id')
const garageAddress = domNode.getAttribute('garage-address')
const showPopup = domNode.getAttribute('garage-show-popup') === 'true'
const popupText = domNode.getAttribute('garage-popup-text') || ''

if (!garageId) throw new Error('Missing garage-id attribute on #react-garage-detail-search root')

const root = createRoot(domNode)

root.render(
    <GarageDetailSearchRoot
        garageId={garageId}
        garageAddress={garageAddress || ''}
        showPopup={showPopup}
        popupText={popupText}
    />
)
